// src/catalog/hooks/useCatalogEntry.js

import { useEffect, useState } from "react";

const apiUrl =
  process.env.REACT_APP_API_URL || "http://localhost:5001/api";

function getAuthToken() {
  return (
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("accessToken")
  );
}

export default function useCatalogEntry(
  slug,
  {
    enabled = true,
    includeDirectLinkOnly = false
  } = {}
) {
  const [entry, setEntry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const endpoint =
    `${apiUrl}/catalog/app/${slug}${
      includeDirectLinkOnly
        ? "?includeDirectLinkOnly=true"
        : ""
    }`;

  useEffect(() => {
    let cancelled = false;

    async function loadCatalogEntry() {
      try {
        if (!enabled) {
          setEntry(null);
          setLoading(false);
          setError("");
          return;
        }

        setLoading(true);
        setError("");

        if (!slug) {
          throw new Error("Catalog entry slug is required");
        }

        const token = getAuthToken();

        if (!token) {
          throw new Error(
            "Catalog request failed: missing auth token"
          );
        }

        const fetchOptions = token
          ? {
              headers: {
                Authorization: `Bearer ${token}`
              }
            }
          : undefined;

        const response = await fetch(
          endpoint,
          fetchOptions
        );

        if (!response.ok) {
          throw new Error(
            `Catalog request failed: ${response.status}`
          );
        }

        const data = await response.json();

        if (!cancelled) {
          setEntry(data);
        }
      } catch (err) {
        if (!cancelled) {
          setError(
            err.message ||
              "Could not load catalog entry"
          );
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadCatalogEntry();

    return () => {
      cancelled = true;
    };
  }, [enabled, endpoint, slug]);

  return {
    entry,
    loading,
    error
  };
}
